import { BodyM, Heading4 } from '@casavo/base-ui'
import getConfig from 'next/config'
import React from 'react'

import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'

import { bannerListItem } from '../styles.css'

export type BannerListItem = {
  description?: string
  image?: string
  imageSize?: 's' | 'm'
  title: string
}

const BannerListComponent: React.FC<BannerListItem> = ({ description, image, imageSize = 's', title }) => {
  if (!title) {
    return null
  }
  const imageSrc = image || 'check'
  const compoundImageSize = imageSize === 's' ? 20 : 48

  const {
    publicRuntimeConfig: { imageBasePath },
  } = getConfig()

  return (
    <div className={bannerListItem}>
      <img
        alt=""
        className={sprinkles({ flexShrink: 0, marginRight: 'm' })}
        height={compoundImageSize}
        src={`${imageBasePath}/images/banner-casavo-property/${imageSrc}.svg`}
        width={compoundImageSize}
      />
      <div>
        <BodyM strong className={sprinkles({ textTransform: 'uppercase' })}>
          {title}
        </BodyM>

        {description && <BodyM>{description}</BodyM>}
      </div>
    </div>
  )
}

export default BannerListComponent
